<div
  *ngIf="title && title.text"
  [style.color]="textColor"
  [style.fontSize.px]="title.size"
  [style.textAlign]="title.align"
  class="title"
>
  {{ title.text }}
</div>

<div
  *ngIf="this.chartOptions.transpose === 'rows'"
  [class.paginated-table]="pages?.length > 1"
  class="table-container"
>
  <table
    class="ui very basic table"
    [style.color]="textColor"
    [style.fontSize.px]="textSize"
  >
    <thead *ngIf="result">
      <tr>
        <th
          *ngIf="result.query?.rollup?.value !== 'total'"
          class="min-width dimension"
          [style.color]="textColor"
        >
          {{ result.query?.rollup?.name }}
        </th>
        <ng-container *ngFor="let dimension of result.dimensions">
          <th
            class="min-width dimension"
            [style.color]="textColor"
          >
            {{ dimension.displayName }}
          </th>

          <th
            *ngFor="let property of dimension.properties"
            class="min-width wrapped dimension"
            [style.color]="textColor"
          >
            {{ dimension.displayName }}
            <br />
            {{ property.displayName }}
          </th>
        </ng-container>

        <th class="spacer"></th>
        <th
          *ngFor="let metric of result.metrics"
          [wrapMiddle]="metric.displayName"
          class="metric"
          [style.color]="textColor"
        ></th>
      </tr>
    </thead>

    <tbody *ngIf="result && pages?.length">
      <tr
        *ngFor="let row of pages[currentPageNum]; let i = index"
        class="clickable"
      >
        <td *ngIf="result.query?.rollup?.value !== 'total'">{{ row.date | date : dateFormat }}</td>
        <ng-container *ngFor="let slice of row.slices">
          <td>{{ slice.value | format : slice.format }}</td>

          <td *ngFor="let property of slice.properties">{{ property.value | format : property.format }}</td>
        </ng-container>

        <td class="spacer"></td>
        <td
          *ngFor="let metric of row.metrics; let index = index"
          [style]="{ 'background-color': conditionalColor(index, metric) }"
          class="metric"
        >
          <span class="value">{{ metric.value | format : getMetricFormat(metric.name, metric.format) }}</span>
          <benchmark-result
            [style.fontSize.px]="textSize * 0.86"
            [benchmark]="
              benchmarkPages &&
              benchmarkPages[currentPageNum] &&
              benchmarkPages[currentPageNum][i] &&
              benchmarkPages[currentPageNum][i][metric.name]
            "
            [benchmarkClassName]="
              benchmarkPages &&
              benchmarkPages[currentPageNum] &&
              benchmarkPages[currentPageNum][i] &&
              benchmarkPages[currentPageNum][i][metric.name]
                ? getBenchmarkClassNames(getComparison(metric), benchmarkPages[currentPageNum][i][metric.name])
                : ''
            "
            [timePeriod]="compareTo"
            [loadingBenchmarks]="loadingBenchmarks"
          ></benchmark-result>
        </td>
      </tr>
      <tr *ngIf="showColumnGrandTotals">
        <td class="total">Page Total</td>
        <td class="spacer" *ngIf="result.query?.rollup?.value !== 'total'"></td>
        <td class="spacer" *ngFor="let element of emptyTableCells"></td>
        <td
          *ngFor="let metricTotal of datesAsRowsTotals"
          class="metric summary"
        >
          <ng-container *ngIf="!metricTotal.hide">{{ metricTotal.value | format : metricTotal.format }}</ng-container>
        </td>
      </tr>
      <tr *ngIf="showColumnAllPagesTotals">
        <td class="total">Grand Total</td>
        <td class="spacer" *ngIf="result.query?.rollup?.value !== 'total'"></td>
        <td class="spacer" *ngFor="let element of emptyTableCells"></td>
        <td
          *ngFor="let metric of result.metrics"
          class="metric summary"
        >
          {{
            result.totals[metric.name]?.value !== null
              ? (result.totals[metric.name].value
                | format : getMetricFormat(metric.name, result.totals[metric.name].format))
              : '-'
          }}
        </td>
      </tr>
    </tbody>
  </table>
  <pagination
    [pages]="pages"
    [initialPage]="initialPageNum"
    [resetPageNumOnChange]="true"
    (currentPageNumChange)="updateCurrentPageNum($event)"
  ></pagination>
</div>

<div
  *ngIf="this.chartOptions.transpose === 'columns'"
  [class.paginated-table]="uniqueSlices?.length > 1"
  class="table-container"
>
  <table
    class="ui celled structured table"
    [style.color]="textColor"
    [style.backgroundColor]="backgroundColor"
    [style.fontSize.px]="textSize"
  >
    <thead
      *ngIf="result"
      [style.backgroundColor]="backgroundColor"
    >
      <tr>
        <ng-container *ngFor="let dimension of result.dimensions">
          <th
            rowspan="2"
            [style.color]="textColor"
            [style.backgroundColor]="backgroundColor"
          >
            {{ dimension.displayName }}
          </th>
          <th
            *ngFor="let property of dimension.properties"
            rowspan="2"
            [style.color]="textColor"
            [style.backgroundColor]="backgroundColor"
            class="wrapped"
          >
            {{ dimension.displayName }}
            <br />
            {{ property.displayName }}
          </th>
        </ng-container>
        <th
          *ngFor="let metric of result.metrics"
          class="center aligned"
          [attr.colspan]="uniqueDates.length"
          [style.color]="textColor"
          [style.backgroundColor]="backgroundColor"
        >
          {{ metric.displayName }}
        </th>
        <ng-container *ngIf="showRowGrandTotals">
          <th
            *ngFor="let metric of result.metrics"
            class="center aligned"
            [attr.colspan]="uniqueDates.length"
            [style.color]="textColor"
            [style.backgroundColor]="backgroundColor"
          >
            {{ metric.displayName }}
          </th>
        </ng-container>
      </tr>
      <tr *ngIf="result.query?.rollup?.value !== 'total'">
        <ng-container *ngFor="let metric of result.metrics">
          <th
            *ngFor="let date of uniqueDates"
            [style.color]="textColor"
            [style.backgroundColor]="backgroundColor"
          >
            {{ date | date : dateFormat }}
          </th>
        </ng-container>
        <ng-container *ngIf="showRowGrandTotals">
          <th
            *ngFor="let metric of result.metrics"
            class="center aligned"
            [attr.colspan]="uniqueDates.length"
            [style.color]="textColor"
            [style.backgroundColor]="backgroundColor"
          >
            Page Total
          </th>
        </ng-container>
      </tr>
    </thead>

    <tbody *ngIf="result">
      <tr
        *ngFor="let row of uniqueSlices[currentPageNum]; let index = index"
        class="clickable"
      >
        <ng-container *ngFor="let slice of row">
          <td>{{ slice.value }}</td>
          <td *ngFor="let property of slice.properties">{{ property.value | format : property.format }}</td>
        </ng-container>
        <ng-container
          *ngFor="let metric of resultSeries[index + resultsPerPage * currentPageNum].metrics; let metricIndex = index"
        >
          <ng-container *ngFor="let value of metric.values; let valueIndex = index">
            <td
              [style]="{ 'background-color': conditionalColor(valueIndex, metric) }"
              class="metric"
            >
              <span class="value">{{ value | format : getMetricFormat(metric.name, metric.format) }}</span>
              <benchmark-result
                [style.fontSize.px]="textSize * 0.86"
                [benchmark]="
                  benchmarkPages &&
                  benchmarkPages[currentPageNum] &&
                  benchmarkPages[currentPageNum][index] &&
                  benchmarkPages[currentPageNum][index][metric.name] &&
                  benchmarkPages[currentPageNum][index][metric.name][valueIndex]
                "
                [benchmarkClassName]="
                  benchmarkPages &&
                  benchmarkPages[currentPageNum] &&
                  benchmarkPages[currentPageNum][index] &&
                  benchmarkPages[currentPageNum][index][metric.name] &&
                  benchmarkPages[currentPageNum][index][metric.name][valueIndex]
                    ? getBenchmarkClassNames(
                        getComparison(metric),
                        benchmarkPages[currentPageNum][index][metric.name][valueIndex]
                      )
                    : ''
                "
                [timePeriod]="compareTo"
                [loadingBenchmarks]="loadingBenchmarks"
              ></benchmark-result>
            </td>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showRowGrandTotals">
          <td
            *ngFor="let metricTotal of datesAsColumnsRowTotals[index]"
            [attr.colspan]="uniqueDates.length"
            class="metric summary"
          >
            {{ metricTotal.value | format : metricTotal.format }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="showColumnGrandTotals">
        <td class="total">Page Total</td>
        <ng-container *ngFor="let element of emptyTableCells">
          <td *ngIf="emptyTableCells.at(-1) !== element"></td>
        </ng-container>
        <td
          *ngFor="let metricTotal of datesAsColumnsColTotals"
          class="metric summary"
        >
          <ng-container *ngIf="!metricTotal.hide">{{ metricTotal.value | format : metricTotal.format }}</ng-container>
        </td>
        <ng-container *ngIf="showRowGrandTotals">
          <td
            *ngFor="let metricTotal of datesAsColumnsTotalOfTotals"
            [attr.colspan]="uniqueDates.length"
            class="metric summary"
          >
            <ng-container *ngIf="!metricTotal.hide">{{ metricTotal.value | format : metricTotal.format }}</ng-container>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>

  <pagination
    [pages]="uniqueSlices"
    [initialPage]="initialPageNum"
    [resetPageNumOnChange]="true"
    (currentPageNumChange)="updateCurrentPageNum($event)"
  ></pagination>
</div>

<div
  *ngIf="!!footer"
  class="table-footer"
>
  <span *ngIf="footer.datasetInfo">{{ footerData.datasetInfo }}</span>
  <span *ngIf="footer.dateRange">{{ footerData.dateRange }}</span>
</div>
